
import React      from 'react';
import ReactDOM   from 'react-dom';
import Spinner    from '_views/shared/Spinner';
import TagModel   from '_legacy-models/TagModel';
import UiHelper   from '_utils/UiHelper';

import {toClassStr} from '_utils/UiHelper';

class GenomeSidebarPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCollapsed: this.props.isInitiallyCollapsed,
      hasAppeared: false,
      isSidebarFrozen: this.props.isFrozen
    };

    this.appearanceTimeout = null;
    this.Tag = new TagModel;

    this.panel3 = {};
    this.panel4 = {};

    /*
      this.props:
        addClasses,
        hasSeoTags,
        heading,
        headingPath,
        isInitiallyCollapsed,
        isLoading,
        isFrozen,
        isOpen,
        onAppear,
        onClose,
        onCollapse,
        panel,
        shouldAnimateAppearance,
        tags,
    */
  }

  componentDidMount() {
    if (this.props.shouldAnimateAppearance && !this.state.hasAppeared) {
      this.appearanceTimeout = setTimeout(() => {
        this.invokeAppearance();
        this.wireOnLingerBehavior();
        this.checkIfSidebarIsFrozen();
        clearTimeout(this.appearanceTimeout);
      }, 300);
    }
  }

  componentDidUpdate() {
    this.wireOnLingerBehavior();
    this.checkIfSidebarIsFrozen();
  }

  render() {
    let isOpen = (this.props.isOpen) ? 'is-open' : 'is-closed';
    let isCollapsed = (this.state.isCollapsed) ? 'is-collapsed' : '';
    let isLoading = (this.props.isLoading) ? 'is-loading' : '';
    let classes = toClassStr(['genome-sidebar-panel', isCollapsed, isOpen, isLoading, this.props.addClasses]);

    return (
      <div className={classes}>

        <div className="sidebar-panel-header">
          {this.renderSidebarHeading()}
        </div>

        {this.renderSpinner()}

        <ul className="tags-list">
          {this.renderTags()}
        </ul>
      </div>
    );
  }

  renderSidebarHeading() {
    const headingPath = this.props.headingPath ? this.props.headingPath.replace(/\/$/, '') : '';

    if (this.props.panel == 4) {
      return (
        <h6 className="sidebar-panel-heading">
          <a className="sidebar-panel-heading-link" href={headingPath}>{this.props.heading}</a>
        </h6>
      );
    }

    if (this.props.panel == 3) {
      return (
        <h5 className="sidebar-panel-heading">
          <a className="sidebar-panel-heading-link" href={headingPath}>{this.props.heading}</a>
        </h5>
      );
    }

    if (this.props.panel == 2) {
      return (
        <h4 className="sidebar-panel-heading">
          <a className="sidebar-panel-heading-link" href={headingPath}>{this.props.heading}</a>
        </h4>
      );
    }

    return (
      <h3 className="sidebar-panel-heading">
        <a className="sidebar-panel-heading-link" href={headingPath}>{this.props.heading}</a>
      </h3>
    );
  }

  renderSpinner() {
    if (!this.props.isLoading) {
      return null;
    }

    return (
      <Spinner />
    );
  }

  renderTags() {
    if (!(this.props.tags && this.props.tags.length && this.props.tags.length > 0)) {
      return null;
    }

    let tags = this.props.tags.map((tag, index) => {
      if (this.props.hasSeoTags) {
        return this.renderAnchorTag(tag, index);
      } else {
        return this.renderJsTag(tag, index);
      }
    });

    return tags;
  }

  renderAnchorTag(tag, index) {
    let classes = toClassStr(["tag", tag.role, tag.display_type]);
    const tagPath = this.getTagPath(tag);

    return(
      <li className={classes} key={index} >
        <a className="tag-link" href={tagPath} data-title={tag.name} data-id={tag.tag_id} data-key={tag.key} data-path={tagPath} onClick={(e) => {this.handleTagLinkClick(e)}}>
          {tag.name}
        </a>
        {this.renderSpinner()}
      </li>
    );
  }

  renderJsTag(tag, index) {
    let classes = toClassStr(["tag", tag.role, tag.display_type]);
    const tagPath = this.getTagPath(tag);

    return(
      <li className={classes} key={index}>
        <div className="tag-link tag-js-link" data-title={tag.name} data-path={tagPath} data-id={tag.tag_id} data-key={tag.key} onClick={(e) => {this.handleJsTagLinkClick(e, tag)}}>
          {tag.name}
        </div>
      </li>
    );
  }

  renderGenomeSidebarPanel3(opts) {
    const panel3Container = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.react');

    ReactDOM.render(
      <GenomeSidebarPanel
        key="panel3"
        panel={3}
        heading={opts.heading}
        headingPath={opts.headingPath}
        tags={opts.tags}
        isInitiallyCollapsed={false}
        isOpen={opts.isOpen}
        isLoading={opts.isLoading}
        isFrozen={this.state.isSidebarFrozen}
        hasSeoTags={false}
        shouldAnimateAppearance={opts.shouldAnimateAppearance}
        onAppear={opts.onAppear}
        onClose={opts.onClose}
        onCollapse={opts.onCollapse}
      />, panel3Container
    );
  }

  renderGenomeSidebarPanel4(opts) {
    const panel4Container = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.react');

    ReactDOM.render(
      <GenomeSidebarPanel
        key="panel4"
        panel={4}
        heading={opts.heading}
        headingPath={opts.headingPath}
        tags={opts.tags}
        isInitiallyCollapsed={false}
        isOpen={opts.isOpen}
        isLoading={opts.isLoading}
        isFrozen={this.state.isSidebarFrozen}
        hasSeoTags={false}
        shouldAnimateAppearance={opts.shouldAnimateAppearance}
        onAppear={opts.onAppear}
        onClose={opts.onClose}
        onCollapse={opts.onCollapse}
      />, panel4Container
    );
  }

  handleTagLinkClick(e, tag) {
    e.stopPropagation();
    this.showContentLoading();
    this.freezeSidebar();
  }

  handleJsTagLinkClick(e, tag) {
    e.stopPropagation();
    const tagPath = this.getTagPath(tag);

    this.showContentLoading();
    this.freezeSidebar();

    if (tagPath) {
      location.href = tagPath;
    }
  }

  handlePanel2TagLinger(e) {
    if (this.state.isSidebarFrozen) {
      return false;
    }

    const reactPanel3 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-3.react .genome-sidebar-panel');

    const reactPanel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.react .genome-sidebar-panel');

    const parentTagLink = e.target.querySelector('.tag-link');
    const parentTagName = parentTagLink.innerText;
    const parentTagPath = parentTagLink.getAttribute('data-path');
    const parentTagKey = parentTagLink.getAttribute('data-key');
    const parentTagId = parentTagLink.getAttribute('data-id');

    this.panel3.parentTagId = parentTagId;

    this.renderGenomeSidebarPanel3({
      heading: parentTagName,
      headingPath: parentTagPath,
      tags: [],
      isOpen: (reactPanel3) ? true : false,
      isLoading: true,
      shouldAnimateAppearance: true,
      onAppear: () => {
        this.renderGenomeSidebarPanel3({
          heading: parentTagName,
          headingPath: parentTagPath,
          tags: [],
          isOpen: true,
          isLoading: true,
          onClose: () => {
            this.renderGenomeSidebarPanel3({
              isOpen: false
            });
          }
        });
      },
      onClose: () => {
        this.renderGenomeSidebarPanel3({
          isOpen: false
        });
      }
    });

    this.renderGenomeSidebarPanel4({
      tags: [],
      isOpen: false,
      isLoading: false,
      shouldAnimateAppearance: true,
    });

    this.getTagChildren(parentTagId, (requestParentTagId, childTags) => {

      if (this.state.isSidebarFrozen) {
        return null;
      }

      if (requestParentTagId != this.panel3.parentTagId) {
        return null;
      }

      this.renderGenomeSidebarPanel3({
        heading: parentTagName,
        headingPath: parentTagPath,
        tags: childTags,
        isOpen: true,
        isLoading: false,
        onAppear: () => {
          this.renderGenomeSidebarPanel3({
            heading: parentTagName,
            headingPath: parentTagPath,
            tags: childTags,
            isOpen: true,
            isLoading: false,
            onClose: () => {
              this.renderGenomeSidebarPanel3({
                isOpen: false
              });
            }
          });
        },
        onClose: () => {
          this.renderGenomeSidebarPanel3({
            isOpen: false
          });
        }
      });
    });
  }

  handlePanel3TagLinger(e) {
    if (this.state.isSidebarFrozen) {
      return false;
    }

    const reactPanel4 = document.querySelector('.genome-sidebar .genome-sidebar-panels .panel-4.react .genome-sidebar-panel');

    const parentTagLink = e.target.querySelector('.tag-link');
    const parentTagName = parentTagLink.innerText;
    const parentTagPath = parentTagLink.getAttribute('data-path');
    const parentTagKey = parentTagLink.getAttribute('data-key');
    const parentTagId = parentTagLink.getAttribute('data-id');

    this.panel4.parentTagId = parentTagId;

    this.renderGenomeSidebarPanel4({
      heading: parentTagName,
      headingPath: parentTagPath,
      tags: [],
      isOpen: (reactPanel4) ? true : false,
      isLoading: true,
      shouldAnimateAppearance: true,
      onAppear: () => {
        this.renderGenomeSidebarPanel4({
          heading: parentTagName,
          headingPath: parentTagPath,
          tags: [],
          isOpen: true,
          isLoading: true,
          onClose: () => {
            this.renderGenomeSidebarPanel4({
              isOpen: false
            });
          }
        });
      },
      onClose: () => {
        this.renderGenomeSidebarPanel4({
          isOpen: false
        });
      }
    });

    this.getTagChildren(parentTagId, (requestParentTagId, childTags) => {
      if (this.state.isSidebarFrozen) {
        return null;
      }

      if (requestParentTagId != this.panel4.parentTagId) {
        return null;
      }

      this.renderGenomeSidebarPanel4({
        heading: parentTagName,
        headingPath: parentTagPath,
        tags: childTags,
        isOpen: true,
        isLoading: false,
        onAppear: () => {
          this.renderGenomeSidebarPanel4({
            heading: parentTagName,
            headingPath: parentTagPath,
            tags: childTags,
            isOpen: true,
            isLoading: false,
            onClose: () => {
              this.renderGenomeSidebarPanel4({
                isOpen: false
              });
            }
          });
        },
        onClose: () => {
          this.renderGenomeSidebarPanel4({
            isOpen: false
          });
        }
      });
    });
  }

  getTagChildren(tagId, callback) {
    this.Tag.children({
      tagId: tagId,
      done: (data) => {
        if (callback) {
          callback(tagId, data);
        }
      },
      fail: (message) => {
        console.log ('something went wrong in Tag.children. message:', message);
      }
    });
  }

  getTagPath(tag) {
    if (!tag) {
      return '';
    }

    const tagPath = tag.route;
    return (tagPath) ? tagPath.replace(/\/$/, '') : '';
  }

  showContentLoading() {
    const contentBlock = document.querySelector('.genome-page .genome-page-content');
    contentBlock.classList.add('is-loading');
  }

  invokeAppearance() {
    if (this.props.onAppear) {
      this.props.onAppear();

      this.setState({
        hasAppeared: true
      });
    }
  }

  wireOnLingerBehavior() {
    if (this.props.panel == 2) {
      
      const panel2Tags = document.querySelectorAll('.genome-sidebar .panel-2.react .genome-sidebar-panel .tags-list .tag');

      if (panel2Tags.length > 0) {
        panel2Tags.forEach((tag, index) => {
          if (tag.classList.contains('branch')) {
            UiHelper.onLinger(tag, (e) => {
              this.handlePanel2TagLinger(e);
            });
          }
        });
      }
    }

    if (this.props.panel == 3) {
      
      const panel3Tags = document.querySelectorAll('.genome-sidebar .panel-3.react .genome-sidebar-panel .tags-list .tag');

      if (panel3Tags.length > 0) {
        panel3Tags.forEach((tag, index) => {
          if (tag.classList.contains('branch')) {
            UiHelper.onLinger(tag, (e) => {
              this.handlePanel3TagLinger(e);
            });
          }
        });
      }
    }
  }

  freezeSidebar() {
    this.setState({
      isSidebarFrozen: true
    });
  }

  checkIfSidebarIsFrozen() {
    if (this.props.isFrozen) {
      this.freezeSidebar();
    }
  }
}

export default GenomeSidebarPanel;
